import { Pill } from "../pill";

export const LicencePill = ({ license = {}, setLicense }) => {
	let variant = "";
	if (!license.lastActivatedUtc) variant = "outline-";

	switch (license?.state) {
		case "Error":
		case "Expired":
			variant += "danger";
			break;
		case "Subscription disabled":
			variant += "dark";
			break;
		case "Revoked":
			variant += "warning";
			break;
		case "Not activated":
		default:
			variant += "success";
	}

	return (
		<Pill
			tooltip={
				<>
					{license?.offering?.name}
					<br />
					{license?.state}
				</>
			}
			variant={variant}
			onClick={() => setLicense(JSON.parse(JSON.stringify(license)))}
			text={license?.subscription?.name}
		/>
	);
};
